<template name="referrer" content="no-referrer">
	<div>
	<!-- 卡片试图区域 -->
	<el-card>
	  <!-- 搜索与添加区域 -->
		<el-row :gutter="20">
			<el-col :span="8">
				<el-input
				placeholder="请输入内容"
				v-model="queryInfo.query"
				clearable
				:changeValue="changeValue"
				@clear="getUserList"
				>
				    <el-button
					slot="append"
					icon="el-icon-search"
					@click="getUserList"
					></el-button>
				  </el-input>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="addDialogVisible = true">新增</el-button>
					</el-col>
		</el-row>
		<!-- 用户列表区域 -->
		 <el-table
		      :data="userlist"
			  border
			  stripe>
			  <el-table-column
			    type="index"
			   >
			  </el-table-column>
		      <el-table-column
		        prop="name"
		        label="名称">
		      </el-table-column>
		      <el-table-column
		        prop="content"
		        label="内容">
		      </el-table-column>
			  <el-table-column label="封面"  prop="cover_img">
				　<template slot-scope="scope">
				　　　<img :src="scope.row.cover_img" v-if="scope.row.cover_img !=1" width="200px" height="200px" />
			       	<img  src="../../assets/img/covernull.png" width="200px" height="200px" v-else/>
				　　</template>
			  </el-table-column>
			  <el-table-column
			    prop="create_time"
			    label="日期">
          <template slot-scope="scope">
          					 {{scope.row.create_time | fmtdate}}
          </template>
			  </el-table-column>
			  <el-table-column
			    prop="state"
			    label="状态">
			  </el-table-column>
			  <el-table-column
			    prop="username"
			    label="用户">
			  </el-table-column>
			  <el-table-column
			    label="操作">
				<template slot-scope="scope">
					<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
					 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
					   </el-tooltip>
					 <!--  {{scope.row}} -->
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
					 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.id)"></el-button>
					   </el-tooltip>
					</template>
			  </el-table-column>
		    </el-table>
		<!-- 分页区域 -->
		<el-pagination
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="queryInfo.pagenum"
		      :page-sizes="[1, 2, 5, 10]"
		      :page-size="queryInfo.pagesize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
	</el-card>
	<!-- 添加对话框 -->
	<el-dialog
	  title="添加"
	  :visible.sync="addDialogVisible"
	  width="70%"
	  @close="addDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="addFormRules"
	 ref="addFormRef"
	 :model="addForm"
	 label-width="80px">
	   <el-form-item label="标题" prop="name">
	     <el-input v-model="addForm.name"></el-input>
	   </el-form-item>

	  <el-form-item label="封面" prop="cover_img">
		  <!-- 用来显示封面的图片 -->
		  <img
		  src="../../assets/img/coverimg.png"
		  alt=""
		  ref='imgRef'
		  width="250px"
		  height="250px"
		  />
		  <br />
		<!-- 文件选择框，默认被隐藏 -->
	     <input
		 type='file'
		 style="display:none"
		 accept='image/*'
		 ref='iptFileRef'
		 @change="changeCoverFn"
		 />
		 <!-- 选择封面的按钮 -->
		 <el-button type='text' @click="selCoverFn">+ 选择图片</el-button>
	   </el-form-item>
     <el-form-item label="内容" prop="content">
       <div style="border: 1px solid #ccc;">
              <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
              />
              <Editor
                  style="height: 500px; overflow-y: hidden;"
                  v-model="addForm.content"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
              />
          </div>
     </el-form-item>
	   <el-form-item prop="state">
		   <el-button type="primary"  @click="pubArticle('已发布')" >新增</el-button>
		   <el-button type="info"  @click="pubArticle('草稿')">存为草稿</el-button>
	   </el-form-item>
	   </el-form>
	</el-dialog>
	<!-- 修改用户的对话框 -->
	<el-dialog
	  title="修改"
	  :visible.sync="editDialogVisible"
	  width="70%"
	  @close="editDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="editFormRules"
	 ref="editFormRef"
	 :model="editForm"
	 label-width="80px">
	   <el-form-item label="标题" prop="name">
	     <el-input v-model="editForm.name"></el-input>
	   </el-form-item>

	   <el-form-item label="图片" prop="cover_img">
				<div class="spec-preview">
				<img :src="this.editTp"  alt="" ref='editimgRef' v-if='this.editTp !=1'/>
				<img src="../../assets/img/covernull.png"  alt="" ref='editimgRef' v-else/>
				  <div class="event" @mousemove="handler"></div>
				  <div class="big">
					<img :src="this.editTp" alt="" ref='big' v-if='this.editTp !=1'/>
					<img src="../../assets/img/covernull.png" alt="" ref='big'  v-else/>
				  </div>
					<!-- 遮罩层 -->
				  <div class="mask" ref="mask"></div>
				</div>
	   		  <br/>
	   		<!-- 文件选择框，默认被隐藏 -->
	       <input
	   		 type='file'
	   		 style="display:none"
	   		 accept='image/*'
	   		 ref='editiptFileRef'
	   		 @change="editchangeCoverFn"
	   		 />
	   		<el-button type='text' @click="editselCoverFn">+ 选择图片</el-button>
	    </el-form-item>
      <el-form-item label="内容" prop="content">
        <!-- <el-input v-model="editForm.content"></el-input> -->
        <div style="border: 1px solid #ccc;">
               <Toolbar
                   style="border-bottom: 1px solid #ccc"
                   :editor="editor"
                   :defaultConfig="toolbarConfig"
                   :mode="mode"
               />
               <Editor
                   style="height: 500px; overflow-y: hidden;"
                   v-model="editForm.content"
                   :defaultConfig="editorConfig"
                   :mode="mode"
                   @onCreated="onCreated"
               />
           </div>
      </el-form-item>
	    <el-form-item prop="state">
	   		   <el-button type="primary"  @click="pubArticle1('已发布')" >确定</el-button>
	   		   <el-button type="info"  @click="pubArticle1('草稿')">存为草稿</el-button>
	    </el-form-item>
	   </el-form>
	</el-dialog>
		</div>
</template>

<script>

import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	//标签和样式钟，引入图片文件可以写路径，在js里引入图片文件要import引入
	//webpack会把图片变成为一个base64字符串/在打包后的图片临时地址
	import imgObj from '../../assets/img/coverimg.png'
	export default{
    components: { Editor, Toolbar },
		data(){
			return{
         editor: null,
         //html: '<p>hello</p>',
         toolbarConfig: { },
         editorConfig: {
         placeholder: '请输入内容...' ,
         MENU_CONF: {
         //配置上传图片
         uploadImage: {
         customUpload: this.uploadImg
           		}
           	}
           },
         mode: 'default', // or 'simple'
        //-----------------------
				//获取样品列表的参数对象
				queryInfo:{
					query:'',
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:5,
				},
				total:0,
				userlist:[],
				editTp:'',
				//控制添加对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改对话框的显示与隐藏
				editDialogVisible:false,
				//添加的表单数据
				addForm:{
					name:'',
					content:'',
					state:'',
					cover_img:'',
					user_id:'',
				},
                //添加表单的验证规则对象
				addFormRules:{
					name:[
						{required:true,message:'请输入标题',trigger:'blur'},
						{min:2,max:30,message:'名称的长度在2~30字符之间',trigger:'blur'}
					],
					content:[
						{required:true,message:'请填写内容',trigger:'blur'},
            {min:1,message:'内容的长度在小于500字符',trigger:'blur'}
					],
					cover_img:[
						{required:true,message:'请选择封面',trigger:'change'},
					],
				},
				//查询到的用户信息对象
				editForm:{},
				//修改表单的验证规则对象
				editFormRules:{
					name:[
						{required:true,message:'请输入标题',trigger:'blur'},
						{min:2,max:30,message:'名称的长度在2~30字符之间',trigger:'blur'}
					],
					content:[
						{required:true,message:'请填写内容',trigger:'blur'},
            {min:1,message:'内容的长度在小于500字符',trigger:'blur'}
					],
					cover_img:[
						{required:true,message:'请选择封面',trigger:'change'},
					],
				},
			}
		},
		created(){
			this.getUserList()

		},
		computed:{
			//监听输入框是否有值，边打字边搜索
			changeValue(e){
				if(this.queryInfo.query){
					return this.queryInfo.pagenum = 1
					}

			}
		},
     mounted() {
            // 模拟 ajax 请求，异步渲染编辑器
            // setTimeout(() => {
            //     this.addForm.content = '<p>模拟 Ajax 异步设置内容 HTML</p>'
            // }, 1500)
        },
        // 组件销毁时，及时销毁编辑器
        beforeDestroy() {
            const editor = this.editor
            if (editor == null) return
            editor.destroy()
        },
		methods:{
        //上传图片
              uploadImg(file, insertFn){
                  let imgData = new FormData();
      			     imgData.append('file', file);
                   //调接口，上传图片
                  testUpImg(imgData).then(response => {
                      if(response.data.code == 0){
                          insertFn(response.data.data.url);
                      }else{
                      }
                  })
              },
       onCreated(editor) {
                  this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
              },
			//放大镜----------------
			handler(event){
				let mask = this.$refs.mask;
				let big = this.$refs.big;
				let left = event.offsetX - mask.offsetWidth/2;
				let top = event.offsetY - mask.offsetHeight/2;
				//约束范围
				if (left <= 0) {left = 0}
				if (left >= mask.offsetWidth) {left = mask.offsetWidth}
				if (top <= 0) {top = 0}
				if (top >= mask.offsetHeight) {top = mask.offsetHeight}
				//修改元素left、top属性值
				mask.style.left = left + 'px';
				mask.style.top = top + 'px';
				big.style.left = -2 * left + 'px'
				big.style.top = -2 * top + 'px'
			},
			//获取样品列表数据-------------
			async getUserList(){
				const {data:res} = await this.$http.getArticle({params:this.queryInfo})
				if (res.status !==0){
			     return this.$message.error('获取样品列表失败!')
				}
				this.userlist = res.data
				this.total = res.total
				console.log(this.userlist)
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize){
				console.log(newSize)
				this.queryInfo.pagesize = newSize
				this.getUserList()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage){
				console.log(newPage)
				this.queryInfo.pagenum = newPage
				this.getUserList()
			},

			//新增样品---------------
			//让文件选择窗口出现
			selCoverFn(){
				this.$refs.iptFileRef.click()
			},
			editselCoverFn(){
				this.$refs.editiptFileRef.click()
			},
			//用户选择了封面文件
			changeCoverFn(e){
				//e.target.files拿到选择文件的数组
				const files = e.target.files
				//console.log(files)
				//如果没有选择图片
				if ( files.length===0) {
					this.addForm.cover_img = null
					//显示原本的图片路径
					this.$refs.imgRef.setAttribute('src',imgObj)
				} else{
					this.addForm.cover_img = files[0]
					//console.log(this.addForm.cover_img)
					//this.addForm.cover_img = files[0]
					//把图片文件，要显示到img标签里，图片转出链接
					const url = URL.createObjectURL(files[0])
					//setAttribute指定属性
					this.$refs.imgRef.setAttribute('src',url)
				}

				//让表单单独校验封面的规则
				// this.$refs.addFormRef.validateField('cover_img')
			},
			pubArticle(str){
				this.addForm.state= str
				this.$refs.addFormRef.validate(async valid =>{
				if (valid){
					console.log(this.addForm)
					const fd = new FormData() //准备一个表单数据对象的容器
					//fd.append('参数名',值)
					fd.append('name',this.addForm.name)
					fd.append('content',this.addForm.content)
					fd.append('cover_img',this.addForm.cover_img)
					fd.append('state',this.addForm.state)
					console.log(fd)
					//可以发起添加用户的网络请求
					const {data:res} = await this.$http.addArtcate({data:fd})
					if (res.status !==0){
						return this.$message.error('添加样品失败!')
					}else{
						console.log(fd)
						this.addDialogVisible = false
						this.$message.success('添加样品成功!')
						this.getUserList()
					}
				}else{
					return false //阻止默认行为（因为按钮有默认提交行为）
				}
				})
			},
			//监听添加样品对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
				//显示原本的图片路径
				this.$refs.imgRef.setAttribute('src',imgObj)
			},

           //编辑样品内容--------------------
			//展示编辑用户的对话框
			async showEditDialog(id){
				const {data:res} = await this.$http.byIdArticle(id)
				if (res.status !==0){
					return this.$message.error('查询样品信息失败!')
				}
				this.editForm = res.data
				//必须要个this.editTp 赋值，不然头像回显有问题
				this.editTp = this.editForm.cover_img
				console.log(this.editForm)
				// console.log(this.editTp)
				this.editDialogVisible = true
			},
			//用户选择了封面文件
			editchangeCoverFn(e){
				const files = e.target.files
				console.log(files)
				if (files.length===0) {
					// this.editForm.cover_img = null
					// this.$refs.editimgRef.setAttribute('src',imgObj)
				} else{
					this.editForm.cover_img = files[0]
					//把图片文件，要显示到img标签里，图片转出链接
					const url = URL.createObjectURL(files[0])
					//setAttribute指定属性
					this.$refs.editimgRef.setAttribute('src',url)
					//放大镜
					this.$refs.big.setAttribute('src',url)
				}
			},
		//修改用户信息并提交
		pubArticle1(str){
			this.editForm.state= str
			this.$refs.editFormRef.validate(async valid =>{
				if (!valid) return
				const fd1 = new FormData()
				fd1.append('id',this.editForm.id)
				fd1.append('name',this.editForm.name)
				fd1.append('content',this.editForm.content)
				fd1.append('cover_img',this.editForm.cover_img)
				fd1.append('state',this.editForm.state)
			const {data:res} = await this.$http.uPbyIdArticle({data:fd1})
			if (res.status !==0){
				return this.$message.error('修改样品失败!')
			}
			this.$message.success('修改样品成功!')
			//重新获取用户列表数据
			this.getUserList()
			//隐藏修改用户的对话框
			this.editDialogVisible = false

			})
		},
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()
			//显示原本的图片路径
			//this.$refs.editimgRef.setAttribute('src',imgObj)
		},
		//删除样品信息---------------------------------------
		//根据Id删除对应的用户信息
		async removeUserById(id){

			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该样品, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).catch(err => err)
					//如果用户确认删除，则返回值为字符串 confirm
					console.log(confirmResult)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					//console.log('确认了删除')
					//const {data:res} = await this.$http.delete('users/' + id)
					const {data:res} = await this.$http.delArticle(id)
					if (res.status !==0){
						return this.$message.error('删除样品失败!')
					}
					this.$message.success('删除样品成功!')
					this.getUserList()
		}
		}
	}
</script>

<style lang="less" scoped>
	.header-box {
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	}
	.spec-preview {
	  position: relative;
	  width: 400px;
	  height: 400px;
	  border: 1px solid #ccc;

	  img {
	    width: 100%;
	    height: 100%;
	  }

	  .event {
	    width: 100%;
	    height: 100%;
	    position: absolute;
	    top: 0;
	    left: 0;
	    z-index: 998;
	  }

	  .mask {
	    width: 50%;
	    height: 50%;
	    background-color: rgba(0, 255, 0, 0.3);
	    position: absolute;
	    left: 0;
	    top: 0;
	    display: none;
	  }

	  .big {
	    width: 100%;
	    height: 100%;
	    position: absolute;
	    top: -1px;
	    left: 100%;
	    border: 1px solid #aaa;
	    overflow: hidden;
	    z-index: 998;
	    display: none;
	    background: white;

	    img {
	      width: 200%;
	      max-width: 200%;
	      height: 200%;
	      position: absolute;
	      left: 0;
	      top: 0;
	    }
	  }

	  .event:hover~.mask,
	  .event:hover~.big {
	    display: block;
	  }
	}
</style>
